<script setup lang="ts">
import { computed } from 'vue'

import { Overlay } from '@collector/shared-ui'
import {
  getEventTime,
  getParticipantTeamSide,
} from '@collector/shared-ui-domain'
import { useParticipantById } from '@desktop/views/Relation/composables'
import {
  useBlockades,
  useIncidentName,
} from '@desktop/views/Relation/Sports/composables'
import { injectEventClock } from '@desktop/views/Relation/Sports/provide-inject'

import AssignPlayerSelect from './AssignPlayerSelect.vue'
import { useAssignPlayerOnPitch } from './useAssignPlayerOnPitch'

// composables
const { getIncidentName } = useIncidentName()
const { isPitchBlocked } = useBlockades()

// inject
const eventClock = injectEventClock()

// state
const { init, currentIncident } = useAssignPlayerOnPitch()

const { participant: currentIncidentParticipant } = useParticipantById(
  () => currentIncident.value?.participant_team_id,
)

// computed
const currentIncidentName = computed(() =>
  currentIncident.value
    ? getIncidentName(currentIncident.value.incident_id)
    : null,
)

const teamSide = computed(() =>
  currentIncidentParticipant.value
    ? getParticipantTeamSide(currentIncidentParticipant.value)
    : null,
)

const currentIncidentTime = computed(() =>
  currentIncident.value ? getEventTime(currentIncident.value) : null,
)

const isVisible = computed(() =>
  isPitchBlocked() ? false : currentIncident.value !== null,
)

// init
init()
</script>

<template>
  <Overlay
    class="flex flex-col gap-y-2 p-2 select-none"
    :modelValue="isVisible"
  >
    <div
      class="flex h-8 items-center gap-x-2 pl-2 text-xs font-bold"
      :class="{
        'bg-current-team-home-5': teamSide === 'home',
        'bg-current-team-away-5': teamSide === 'away',
      }"
    >
      {{ eventClock && currentIncidentTime }}
      <span class="truncate">
        {{ currentIncidentName }}
      </span>
    </div>
    <AssignPlayerSelect
      v-if="currentIncident"
      :key="currentIncident.id"
      :incident="currentIncident"
    />
  </Overlay>
</template>
